export default "__VITE_ASSET__CMF5j$dA__"